import { useEffect } from 'react';
import { get } from 'lodash-es';
import { useFetch } from 'srcAlias/utils/useFetch';
import { getApiEndpoint } from 'srcAlias/utils/url';
import { createHeaders } from 'srcAlias/utils/headers';
import config from 'configAlias';
import { useSelector } from 'react-redux';
import { selectSessionId } from 'srcAlias/client/state/selectors';

export const useApplicationSubmitCall = (setApplicationSubmitResponse) => {
  const appConfig = get(config, 'appConfig', {});

  // eslint-disable-next-line
  const sessionId = useSelector(selectSessionId);

  const headersDetails = {
    applicationType: get(appConfig, 'applicationType'),
    channelId: get(appConfig, 'channelId'),
    sessionId: `${sessionId}`,
    countryCode: get(appConfig, 'countryCode'),
    groupMember: get(appConfig, 'groupMember'),
    appEIMId: get(appConfig, 'appEIMId'),
  };
  const apiDomain = getApiEndpoint();
  const apiEndpoint =
    process.env.REACT_APP_CREATE_MOCK_SERVER === 'true'
      ? 'api/v0/account-submission'
      : process.env.REACT_APP_APPLICATION_SUBMISSION_URL;
  const finalUri = `${apiDomain}/${apiEndpoint}`;
  const method = 'POST';
  // eslint-disable-next-line no-console
  console.log(`Making API call to ${finalUri} with method ${method}`);
  const timeoutOptions = {
    min: get(appConfig, 'apiCallTimeOut.eligiblityCall.customerMinTimeout'),
    max: get(appConfig, 'apiCallTimeOut.eligiblityCall.customerMaxTimeout'),
    clientOverallMax: get(
      appConfig,
      'apiCallTimeOut.eligiblityCall.clientOverallMaxTimeout'
    ),
  };

  const productCode = useSelector((state) =>
    get(state, 'productSelection.productCode', '')
  );

  const opts = {
    data: {
      selectedProducts: productCode,
    },
  };

  const { data, error } = useFetch({
    uri: finalUri,
    fetchOptions: {
      method,
      headers: () => {
        return {
          ...createHeaders(headersDetails),
          'content-type': 'application/json',
          'X-HSBC-Application-Type': 'ETB_IAO',
        };
      },
      body: JSON.stringify(opts),
    },
    timeoutOptions,
  });
  console.log('accountlist call', data);
  useEffect(() => {
    setApplicationSubmitResponse({ data, error });
  }, [data, error]);
};

export default useApplicationSubmitCall;
